import { Directive, TemplateRef, ViewContainerRef } from '@angular/core';
import { USE_DATE_TIME_FORMAT } from '../../core/ccomx-date-formats';

@Directive({
  selector: '[appUseDateTimeFormat]',
  standalone: true,
  providers: [{ provide: USE_DATE_TIME_FORMAT, useValue: true }],
})
export class DateTimeFormatDirective {
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {
    this.viewContainer.createEmbeddedView(this.templateRef);
  }
}
